import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const ReturnPolicy = () => {
  useEffect(() => {
    document.title = "Return & Refund Policy - Hyperapt";
    const m = document.querySelector('meta[name="description"]');
    if (m) m.setAttribute("content", "Return & Refund Policies for Hyperapt");
    else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = "Return & Refund Policies for Hyperapt";
      document.head.appendChild(meta);
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-web-bg text-web-text font-web-sans flex flex-col selection:bg-web-primary selection:text-white">
      
      {/* Header - Sleek, centered */}
      <header className="fixed top-0 w-full z-50 bg-white/90 backdrop-blur-md transition-all duration-300 h-20 flex items-center border-b border-web-border/50">
        <div className="max-w-7xl mx-auto px-4 w-full flex items-center justify-center">
          <Link to="/home" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <img src="/logo.png" alt="hyperapt" className="h-8 w-auto" />
            <span className="font-web-serif font-semibold text-[36px] tracking-normal text-web-text">
              hyperapt
            </span>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 w-full max-w-4xl mx-auto px-4 pt-32 pb-24">
        
        <div className="text-center mb-12">
          <h1 className="font-web-serif text-4xl lg:text-5xl font-bold text-web-text mb-4">Return Policy</h1>
          <p className="text-web-text/60 text-lg font-light">Returns & Refunds Information</p>
        </div>

        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-web-border/60">
          
          <section className="mb-12">
            <h2 className="font-web-serif text-2xl font-bold mb-6 text-web-text">Eligibility for Returns</h2>
            <div className="space-y-4 text-web-text/80 leading-relaxed font-light">
              <ul className="list-none space-y-4 pl-0">
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-web-primary/10 flex items-center justify-center text-web-primary shrink-0 mt-0.5">
                    <span className="font-medium text-sm">1</span>
                  </div>
                  <span>Return requests must be initiated within 48 hours of receiving the order.</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-web-primary/10 flex items-center justify-center text-web-primary shrink-0 mt-0.5">
                    <span className="font-medium text-sm">2</span>
                  </div>
                  <span>Products must be in their original packaging, unopened, and unused.</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-web-primary/10 flex items-center justify-center text-web-primary shrink-0 mt-0.5">
                    <span className="font-medium text-sm">3</span>
                  </div>
                  <span>Products that are damaged, defective, or incorrect will be eligible for return.</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-web-primary/10 flex items-center justify-center text-web-primary shrink-0 mt-0.5">
                    <span className="font-medium text-sm">4</span>
                  </div>
                  <span>Products cannot be returned for the reasons of change of mind or convenience.</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-web-primary/10 flex items-center justify-center text-web-primary shrink-0 mt-0.5">
                    <span className="font-medium text-sm">5</span>
                  </div>
                  <span>Certain products such as personal care items, perishable goods, and prescription medications are non-returnable due to hygiene and safety reasons.</span>
                </li>
              </ul>
            </div>
          </section>

          <hr className="border-web-border/50 my-12" />

          <section>
            <h2 className="font-web-serif text-2xl font-bold mb-6 text-web-text">Return Process</h2>
            <div className="bg-web-secondary/10 p-6 rounded-2xl border border-web-border text-center md:text-left flex flex-col md:flex-row items-center justify-between gap-6">
              <div>
                <p className="text-web-text/80 font-medium mb-1">
                  Need to place a return request?
                </p>
                <p className="text-web-text/60 text-sm font-light">
                  If you are eligible for return, please contact our Care Center to initiate the process.
                </p>
              </div>
              <a
                href="tel:9004581717"
                className="shrink-0 px-6 py-3 rounded-full bg-web-primary text-white font-medium shadow-md shadow-web-primary/20 hover:shadow-lg hover:shadow-web-primary/40 transition-all"
              >
                Call Care Center
              </a>
            </div>
          </section>

        </div>
      </main>

      {/* Footer - Sleek & Minimal */}
      <footer className="bg-web-bg text-web-text py-8 border-t border-web-border mt-auto relative z-30">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-6">
          <Link to="/home" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <img src="/logo.png" alt="hyperapt" className="h-8 w-auto opacity-90" />
            <span className="font-web-serif font-semibold text-[32px] tracking-normal text-web-text">
              hyperapt
            </span>
          </Link>

          <nav className="flex flex-wrap justify-center gap-6 text-sm text-web-text/70 font-light">
            <Link to="/trackorder" className="hover:text-web-primary transition-colors">Track Order</Link>
            <Link to="/partner" className="hover:text-web-primary transition-colors">For Doctors</Link>
            <Link to="/terms" className="hover:text-web-primary transition-colors">Terms of Service</Link>
            <Link to="/privacypolicy" className="hover:text-web-primary transition-colors">Privacy Policy</Link>
            <Link to="/returnpolicy" className="hover:text-web-primary transition-colors">Return Policy</Link>
          </nav>

          <div className="text-sm text-web-text/50 font-light">
            © {new Date().getFullYear()} Hyperapt. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ReturnPolicy;